import { createContext } from 'react';

import { ControlSystemReport } from '@totem/components/controlSystemReport/dataTypes';

interface Context {
  onAction?: (action: string) => void;
  loading: boolean;
  reportData: ControlSystemReport;
  totalRecords: number;
}

export default createContext<Context>({
  onAction: () => {},
  loading: false,
  reportData: null,
  totalRecords: 0,
});
